import { render, staticRenderFns } from "./BlacklistsImporter.vue?vue&type=template&id=4f4ec694&"
import script from "./BlacklistsImporter.vue?vue&type=script&lang=js&"
export * from "./BlacklistsImporter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports